import React, { createContext, useCallback, useContext } from 'react';
import { ElementFactory, Question, Serializer } from 'survey-core';
import { ReactQuestionFactory } from 'survey-react-ui';
import CommuteTimeFilter from './CommuteTimeFilter';
import CommuteChipsList from './CommuteChipsList';
import { Neighborhood } from './ListingsMap';
import { JourneyData } from './services/tflApi';

export const NeighbourhoodsContext = createContext<Neighborhood[]>([]);
export const JourneyMapContext = createContext<(map: Map<string, JourneyData>) => void>(() => {});
export const CommuteResetContext = createContext<number>(0);
export const CommuteResultsContext = createContext<{
  ids: string[];
  onRemove: (id: string) => void;
  onClearAll: () => void;
  onOpenMap: () => void;
}>({ ids: [], onRemove: () => {}, onClearAll: () => {}, onOpenMap: () => {} });

class QuestionCommuteFilterModel extends Question {
  getType() { return 'commute-filter'; }
}

ElementFactory.Instance.registerElement('commute-filter', name => new QuestionCommuteFilterModel(name));
Serializer.addClass('commute-filter', [], () => new QuestionCommuteFilterModel(''), 'question');

function CommuteFilterWidget({ question }: { question: QuestionCommuteFilterModel }) {
  const neighbourhoods = useContext(NeighbourhoodsContext);
  const setJourneyMap = useContext(JourneyMapContext);
  const resetKey = useContext(CommuteResetContext);
  const { ids: resultIds, onRemove, onClearAll, onOpenMap } = useContext(CommuteResultsContext);

  const handleResult = useCallback((ids: string[], journeyMap: Map<string, JourneyData>) => {
    question.value = ids.length ? ids : undefined;
    setJourneyMap(journeyMap);
  }, [question, setJourneyMap]);

  const handleClear = useCallback(() => {
    question.value = undefined;
    setJourneyMap(new Map());
  }, [question, setJourneyMap]);

  return (
    <>
      <CommuteTimeFilter
        key={resetKey}
        onResult={handleResult}
        onClear={handleClear}
      />
      <CommuteChipsList
        ids={resultIds}
        neighbourhoods={neighbourhoods}
        onRemove={onRemove}
        onClearAll={onClearAll}
        onOpenMap={onOpenMap}
        limit={8}
      />
    </>
  );
}

ReactQuestionFactory.Instance.registerQuestion('commute-filter', (props: any) =>
  React.createElement(CommuteFilterWidget, { question: props.question as QuestionCommuteFilterModel })
);
